import DocumentsService from '../services/apiRequests/documents.service';
import { s2ab } from '@/utils';

export default {
    namespaced: true,
    state: {
        DocumentList: [],
        ContractList: [],
        ObjectList: [],
        KSKHouseList: [],
        DocTypeList: [],
        Pagination: {},
        ListLength: 0,
        ContractRid: null,
        KSKRid: null,
        file: null,
        document: null
    },
    getters: {},
    mutations: {
        setFile(state, file) {
            state.file = file;
        },
        setContractRid(state, ContractRid) {
            state.ContractRid = ContractRid;
        },
        setKSKRid(state, KSKRid) {
            state.KSKRid = KSKRid;
        },
        setListLength(state, ListLength) {
            state.ListLength = ListLength;
        },
        setPagination(state, Pagination) {
            state.Pagination = Pagination;
        },
        setDocTypeList(state, DocTypeList) {
            state.DocTypeList = DocTypeList;
        },
        setDocumentList(state, DocumentList) {
            state.DocumentList = DocumentList;
        },
        setContractList(state, ContractList) {
            state.ContractList = ContractList;
        },
        setObjectList(state, ObjectList) {
            state.ObjectList = ObjectList;
        },
        setKSKHouseList(state, KSKHouseList) {
            state.KSKHouseList = KSKHouseList;
        },
        setDocument(state, document) {
            state.document = document;
        }
    },
    actions: {
        async getDocumentList({ commit }, { ContractRid, KSKRid, itemsPerPage, currentItem }) {
            let docList = [];
            commit('setDocumentList', []);
            commit('setListLength', 0);
            try {
                let param = {};
                if (ContractRid) {
                    param.contract_rid = ContractRid;
                    commit('setContractRid', ContractRid);
                } else if (KSKRid) {
                    param.ksk_rid = KSKRid;
                    commit('setKSKRid', KSKRid);
                }
                docList = await DocumentsService.getDocumentList(itemsPerPage, currentItem, param);
            } catch (e) {
                console.error(e);
            } finally {
                commit('setDocumentList', docList.data.ahs_documents);
                if (docList && docList.data && docList.data.pagination && docList.data.pagination.row_count)
                    commit('setListLength', docList.data.pagination.row_count);
            }
        },
        async getUserContractsList({ commit }, { ContractRid }) {
            let ContractList = [];
            commit('setContractList', []);
            try {
                ContractList = await DocumentsService.getUserContractsList(ContractRid);
            } catch (e) {
                console.error(e);
            } finally {
                commit('setContractList', ContractList.data.contracts);
            }
        },
        async getUserObjectContractsList({ commit }, { ContractRid }) {
            let list = [];
            commit('setObjectList', []);
            try {
                list = await DocumentsService.getUserObjectContractsList(ContractRid);
            } catch (e) {
                console.error(e);
            } finally {
                commit('setObjectList', list.data.object_contracts);
            }
        },
        async getKSKHousesList({ commit }, { KSKRid }) {
            let list = [];
            commit('setKSKHouseList', []);
            try {
                list = await DocumentsService.getKSKHousesList(KSKRid);
            } catch (e) {
                console.error(e);
            } finally {
                commit('setKSKHouseList', list.data.houses);
            }
        },
        async getRefAhsDocTypes({ commit }) {
            let list = [];
            commit('setDocTypeList', []);
            try {
                list = await DocumentsService.getRefAhsDocTypes();
            } catch (e) {
                console.error(e);
            } finally {
                commit('setDocTypeList', list.data.doc_types);
            }
        },
        async postDoc({ commit }, { nvcDocumentsData }) {
            try {
                const res = await DocumentsService.postDoc(nvcDocumentsData);
                return res;
            } catch (e) {
                console.error(e);
            } finally {
                // commit('setDocTypeList', list.data.doc_types);
            }
        },
        async attachmentsTempInsert({ commit }, file) {
            let response = await DocumentsService.attachmentsTempInsert(file);
            return response;
        },

        async getFile({ commit }, { iAhsDocument_rid }) {
            try {
                commit('setFile', null);
                const res = await DocumentsService.getFile(iAhsDocument_rid);
                commit('setFile', res);
            } catch (e) {
                console.error(e);
            } finally {
                //commit('setDocTypeList', list.data.doc_types);
            }
        },

        async getAttachment({ commit }, { iAttachmentLinkRid }) {
            try {
                commit('setDocument', null);
                const res = await DocumentsService.getAttachment(iAttachmentLinkRid);
                commit('setDocument', res.attach_file);
            } catch (e) {
                console.error(e);
            }
        },
        async getSignedDocument(_, args) {
            const response = await DocumentsService.getSignedDocument(args.guid);
            if (!response.data.document_to_sign) return false;

            const fileURL = window.URL.createObjectURL(new Blob([s2ab(atob(response.data.document_to_sign))]));
            const fileLink = document.createElement('a');

            fileLink.href = fileURL;
            fileLink.setAttribute('download', 'Sign.pdf.cms');
            document.body.appendChild(fileLink);

            fileLink.click();
            fileLink.remove();

            return true;
        }
    }
};
